import { Service } from "@turizi/shared";

export const AgencyTemplate: Partial<Service> = {
    category: 'agency',

    self_attrs: [
    ],
    booking_attrs: [
    ]

} as const;

export default AgencyTemplate;